import 'gumshoejs/dist/gumshoe.polyfills';
import Gumshoe = require('gumshoejs/dist/gumshoe');
import $ from 'gridstrap/lib/gs-zepto';

export class GSNavBar {
	private root;
	private body;
	private document;
	private gumshoe;

	get isVisible() { return this.root.hasClass('is-visible'); }
	set isVisible(value) { this.root.toggleClass('is-visible', !!value); }

	constructor(root) {
		this.root = $(root);
		this.body = $('body');
		this.document = $(document);

		this.isVisible = this.root.hasClass('is-visible');
		this.body.addClass('has-navbar');

		this.gumshoe = new Gumshoe('.gs-NavBar a', {
			navClass: 'is-active',
			offset: this.root.height() + 20,
			events: true,
			reflow: true
		});

		this.document.on('gumshoeActivate', () => this.isVisible = true);
		this.document.on('gumshoeDeactivate', () => this.isVisible = false);
	}

	gsOnDestroy() {
		this.body.removeClass('has-navbar');
		this.document.off('gumshoeActivate');
		this.document.off('gumshoeDeactivate');
		this.gumshoe.destroy();
	}
}
